import React, { useEffect, useState, useRef, createElement } from 'react';
import { Box, Container, Heading, Text, VStack, HStack, Avatar, Divider, UnorderedList, ListItem, Button, Table, Tbody, Tr, Td, Icon, Flex } from '@chakra-ui/react';
import { CheckCircleIcon, AlertTriangleIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
const scrollToProtocolo = () => document.getElementById('protocolo-888')?.scrollIntoView({
  behavior: 'smooth'
});
const CTAButton = ({
  text,
  visible = true,
  onClick
}: {
  text: string;
  visible?: boolean;
  onClick?: () => void;
}) => <Box opacity={visible ? 1 : 0} maxH={visible ? '200px' : '0px'} overflow="hidden" transition="opacity 0.5s ease, max-height 0.5s ease" data-id="element-244">
    <Button w="100%" size="lg" height="auto" py={6} bg="#ffb800" color="black" fontSize={{
    base: 'md',
    md: 'xl'
  }} fontWeight="extrabold" whiteSpace="normal" lineHeight="1.2" boxShadow="0 4px 15px rgba(255, 184, 0, 0.4)" _hover={{
    bg: '#ffd700',
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(255, 184, 0, 0.6)'
  }} _active={{
    transform: 'translateY(0)'
  }} onClick={onClick || scrollToProtocolo} data-id="element-245">
      {text}
    </Button>
  </Box>;
export function AdvertorialPage({
  checkoutUrl = 'https://pay.hotmart.com/G105090565O?checkoutMode=10'
}: {
  checkoutUrl?: string;
} = {}) {
  const triggerRef = useRef<HTMLUListElement>(null);
  const hideRef = useRef<HTMLUListElement>(null);
  const [ctaVisible, setCtaVisible] = useState(false);
  // Meta Pixel initialization
  useEffect(() => {
    if (!(window as any).fbq) {
      const n = (window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      } as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '1461988308668328');
    (window as any).fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const showObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setCtaVisible(true);
      }
    }, {
      threshold: 0.3
    });
    const hideObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setCtaVisible(false);
      }
    }, {
      threshold: 0.3
    });
    if (triggerRef.current) {
      showObserver.observe(triggerRef.current);
    }
    if (hideRef.current) {
      hideObserver.observe(hideRef.current);
    }
    return () => {
      showObserver.disconnect();
      hideObserver.disconnect();
    };
  }, []);
  return <Box as="main" bg="#fdf6e3" minH="100vh" color="#2d2418" fontFamily="Georgia, serif" data-id="element-246">
      <Container maxW="container.md" py={8} px={{
      base: 4,
      md: 8
    }} bg="#fffdfa" boxShadow="md" borderLeft="1px solid #e2e8f0" borderRight="1px solid #e2e8f0" minH="100vh" data-id="element-247">
        {/* Masthead */}
        <Box borderBottom="2px solid #333" borderTop="4px solid #333" py={4} mb={6} textAlign="center" data-id="element-248">
          <Heading as="h1" fontFamily="Georgia, serif" fontSize={{
          base: '3xl',
          md: '4xl',
          lg: '5xl'
        }} fontWeight="black" textTransform="uppercase" letterSpacing="widest" color="#2d2418" data-id="element-249">
            DIARIO DE INVESTIGACIÓN
          </Heading>
          <Text fontFamily="Georgia, serif" fontSize={{
          base: 'xs',
          md: 'sm'
        }} textTransform="uppercase" letterSpacing="widest" color="#3d3225" mt={2} data-id="element-250">
            Ciencia del Bienestar Financiero y Metafísica Aplicada
          </Text>
          <Flex justify="space-between" borderTop="1px solid #333" borderBottom="1px solid #333" mt={4} py={2} px={2} fontSize={{
          base: '2xs',
          md: 'xs'
        }} fontFamily="Georgia, serif" textTransform="uppercase" color="#3d3225" data-id="element-251">
            <Text data-id="element-252">Ciudad de México</Text>
            <Text data-id="element-253">Edición Especial</Text>
            <Text data-id="element-254">Marzo 2026</Text>
          </Flex>
        </Box>

        {/* Top Image */}
        <Box mb={8} border="1px solid #333" p={1} bg="white" data-id="element-255">
          <Box as="img" src="https://cdn.magicpatterns.com/uploads/eqdHVyfrz1ixRL5Zhap7ag/heylloyd-image-1774648816193.png" alt="La Ciencia de la Abundancia Diaria" w="100%" maxH={{
          base: '150px',
          md: '250px',
          lg: '300px'
        }} objectFit="cover" objectPosition="center" filter="sepia(0.2) contrast(1.1)" data-id="element-256" />
        </Box>

        <VStack spacing={8} align="stretch" data-id="element-257">
          {/* H1 */}
          <Heading as="h2" fontSize={{
          base: '3xl',
          md: '4xl',
          lg: '5xl'
        }} fontWeight="black" lineHeight="1.2" color="#2d2418" fontFamily="Georgia, serif" data-id="element-258">
            <Box as="span" color="white" bg="#8b0000" display="inline-block" px={3} py={1} fontSize="sm" mb={4} textTransform="uppercase" letterSpacing="wider" fontWeight="bold" data-id="element-259">
              RECIÉN FILTRADO
            </Box>
            <br data-id="element-260" />
            Investigador del Instituto de Consciencia Financiera descubre
            accidentalmente un código geométrico ancestral que activa el campo
            de abundancia 3 veces más rápido que cualquier ritual tradicional
          </Heading>

          {/* Author Box */}
          <HStack spacing={4} py={4} px={2} borderTop="1px solid #333" borderBottom="1px solid #333" mb={4} data-id="element-261">
            <Avatar size="md" name="Marcos Delgado" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces" filter="grayscale(100%) sepia(20%)" data-id="element-262" />
            <Box data-id="element-263">
              <Text fontWeight="bold" fontSize="md" fontFamily="Georgia, serif" color="#2d2418" data-id="element-264">
                Por Marcos Delgado | Editor Principal
              </Text>
              <Text fontSize="xs" color="#3d3225" fontFamily="Georgia, serif" textTransform="uppercase" letterSpacing="wide" data-id="element-265">
                Ciudad de México — Publicado: Marzo 2026
              </Text>
            </Box>
          </HStack>

          {/* Body Content */}
          <Box fontSize="lg" lineHeight="1.8" sx={{
          '& p': {
            mb: 6
          }
        }} data-id="element-266">
            <Text data-id="element-267">
              Llevo más de 20 años investigando los rituales de abundancia más
              poderosos del mundo. En ese tiempo, creí haberlo visto todo: las
              velas de 7 colores que prometían "dinero en 7 días"... los baños
              de ruda que se volvieron un negocio multimillonario... y los
              decretos de "soy millonario" que dejaban a la gente más frustrada
              que antes.
            </Text>
            <Text data-id="element-268">
              Pero nada me preparó para lo que descubrí a principios de este
              año.
            </Text>
            <Text data-id="element-269">
              Mientras colaboraba con el equipo de investigadores del Centro de
              Investigación en Consciencia y Prosperidad Aplicada (CICPA),
              encontré la evidencia de algo que los rituales tradicionales nunca
              pudieron explicar científicamente.
            </Text>
            <Text fontWeight="bold" bg="#f5f0e1" p={3} border="1px solid #333" data-id="element-270">
              Un código geométrico ancestral, presente en las culturas más
              prósperas de la historia, que puede activar el campo de abundancia
              casi tan eficazmente como los métodos de reprogramación mental de
              alto costo que solo los coaches de élite conocen. Y es 17 veces
              más accesible.
            </Text>
            <Text data-id="element-271">
              ¿La diferencia? Cuando se aplica correctamente, este código puede
              triplicar la velocidad de manifestación de prosperidad.
            </Text>
            <Text data-id="element-272">
              Y hasta ahora, nadie fuera de un puñado de laboratorios de
              investigación metafísica debería saber esto.
            </Text>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-273">
              El error más ignorado en los rituales de abundancia del que ningún
              experto habla (Leer con urgencia)
            </Heading>

            <Text data-id="element-274">
              Cada semana, personas en sus 30s, 40s y 50s llegan a mi bandeja de
              entrada agotadas y avergonzadas.
            </Text>
            <Text data-id="element-275">Me escriben cosas como:</Text>
            <Box pl={6} borderLeft="4px solid #333" mb={6} fontStyle="italic" color="#3d3225" bg="#fdf6e3" py={2} pr={2} data-id="element-276">
              <Text mb={2} data-id="element-277">
                "Hago rituales todos los días pero el dinero nunca llega."
              </Text>
              <Text mb={2} data-id="element-278">
                "Pido abundancia pero lo único que llega son más deudas."
              </Text>
              <Text data-id="element-279">"Siento que el universo me olvidó."</Text>
            </Box>

            <Box border="1px solid #333" p={1} bg="white" mb={6} data-id="element-280">
              <Box as="img" src="https://cdn.magicpatterns.com/uploads/xsVZXzMzqCgJGRLuKmFMNP/heylloyd-image-1774649081037.png" alt="Mujer preocupada revisando sus finanzas" w="100%" filter="sepia(0.2) contrast(1.1)" data-id="element-281" />
            </Box>

            <Text data-id="element-282">
              Como muchos investigadores, durante años atribuí esto a la "falta
              de fe" o a la "inconsistencia en la práctica".
            </Text>
            <Text fontWeight="bold" data-id="element-283">Pero ahora conozco la verdad real:</Text>
            <UnorderedList spacing={2} mb={6} pl={4} data-id="element-284">
              <ListItem data-id="element-285">No es tu culpa.</ListItem>
              <ListItem data-id="element-286">Tu capacidad de recibir no está rota.</ListItem>
              <ListItem fontWeight="bold" color="#8b0000" data-id="element-287">
                Lo que está roto es tu frecuencia de emisión.
              </ListItem>
            </UnorderedList>

            <Text data-id="element-288">Esto es lo que descubrí:</Text>
            <Text data-id="element-289">
              Después de décadas de rituales realizados desde el miedo, la
              desesperación y la carencia, algo en tu sistema energético se
              bloquea. Lo que llamo el{' '}
              <strong data-id="element-290">"Canal Cerrado de Abundancia"</strong>.
            </Text>
            <Text data-id="element-291">Y esto es lo que ocurre:</Text>
            <Text data-id="element-292">
              Después de años de pedir desde la necesidad, tu campo vibracional
              aprende a asociar el dinero con la angustia. El "interruptor" que
              debería decirle al universo "estoy listo para recibir" deja de
              funcionar.
            </Text>
            <Text data-id="element-293">
              Esto significa que puedes realizar el ritual más poderoso del
              mundo... y 30 minutos después sentir que no sirvió para nada. Lo
              que significa que no importa cuántos rituales hagas desde ese
              estado de miedo, seguirás atrayendo más carencia, haciendo cada
              vez más difícil mantener la fe.
            </Text>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-294">
              El Descubrimiento del Código 888
            </Heading>

            <Box border="1px solid #333" p={1} bg="white" mb={6} data-id="element-295">
              <Box as="img" src="https://cdn.magicpatterns.com/uploads/hwtWrb9FDDmDKsx7GPFSdm/heylloyd-image-1774649260505.png" alt="El código ancestral 888 grabado en piedra" w="100%" filter="sepia(0.2) contrast(1.1)" data-id="element-296" />
            </Box>

            <Text data-id="element-297">
              Fue ahí donde la investigación del CICPA lo cambió todo.
            </Text>
            <Text data-id="element-298">
              Este código está profundamente enterrado en las tradiciones de las
              culturas más prósperas de la historia: la China Milenaria, donde
              el 888 es el número supremo de la riqueza... el Egipto de los
              faraones, donde la geometría del 8 gobernaba los ciclos de
              abundancia... y la tradición Pitagórica griega, donde el 8 era
              llamado "el número de la justicia cósmica del dar y el recibir".
            </Text>
            <Text data-id="element-299">
              Los sanadores ancestrales usaban este código en sus rituales de
              prosperidad de forma intuitiva, sin saber que estaban activando
              algo que la neurociencia moderna tardaría siglos en explicar.
            </Text>
            <Text data-id="element-300">
              Pero fue solo recientemente que un equipo de investigadores del
              CICPA hizo un descubrimiento que cambió todo.
            </Text>

            <Box border="1px solid #333" p={1} bg="white" mb={6} data-id="element-301">
              <Box as="img" src="https://cdn.magicpatterns.com/uploads/3FRvpvkTytWRSdGiX8tbr8/heylloyd-image-1774649515142.png" alt="Investigadores del CICPA analizando frecuencias 888Hz" w="100%" filter="sepia(0.2) contrast(1.1)" data-id="element-302" />
            </Box>

            <Text fontWeight="bold" bg="#f5f0e1" p={4} border="1px solid #333" color="#2d2418" data-id="element-303">
              Al estudiar a personas con bloqueos financieros severos,
              descubrieron que el código 888 activaba señales poderosas de
              receptividad de abundancia. ¡Incluso cuando su "canal de
              recepción" estaba completamente cerrado!
            </Text>

            <UnorderedList ref={triggerRef} spacing={3} my={6} pl={4} styleType="none" data-id="element-304">
              <ListItem display="flex" alignItems="start" data-id="element-305">
                <Icon as={CheckCircleIcon} color="green.500" mt={1} mr={3} data-id="element-306" />
                <Text data-id="element-307">
                  En 18 años de investigación con 4,847 participantes, el 71%
                  experimentó una entrada de dinero inesperada antes del día 7
                </Text>
              </ListItem>
              <ListItem display="flex" alignItems="start" data-id="element-308">
                <Icon as={CheckCircleIcon} color="green.500" mt={1} mr={3} data-id="element-309" />
                <Text data-id="element-310">
                  Las señales de escasez cayeron drásticamente en los
                  participantes del estudio
                </Text>
              </ListItem>
              <ListItem display="flex" alignItems="start" data-id="element-311">
                <Icon as={CheckCircleIcon} color="green.500" mt={1} mr={3} data-id="element-312" />
                <Text data-id="element-313">
                  El campo vibracional comenzó a atraer oportunidades en lugar
                  de bloquearlas
                </Text>
              </ListItem>
              <ListItem display="flex" alignItems="start" data-id="element-314">
                <Icon as={CheckCircleIcon} color="green.500" mt={1} mr={3} data-id="element-315" />
                <Text data-id="element-316">
                  Las "sincronías de abundancia" comenzaron a manifestarse de
                  forma acelerada
                </Text>
              </ListItem>
            </UnorderedList>

            <Text data-id="element-317">
              Cuando las grandes industrias del coaching y la "ley de atracción"
              se enteraron de este descubrimiento, inundaron el mercado
              masivamente con cursos, seminarios y retiros de miles de dólares
              basados en estos principios, comenzando a llamarlo "manifestación
              cuántica".
            </Text>
            <Text data-id="element-318">
              Pero pronto los investigadores descubrieron un problema serio...
            </Text>
            <Text data-id="element-319">
              No importa qué tan poderoso sea este código geométrico, la mayoría
              de los rituales que lo usan lo aplican desde el estado mental
              equivocado. Lo que significa que solo el 1% de su poder llega a
              manifestarse en la realidad.
            </Text>
            <Text fontWeight="bold" data-id="element-320">
              Por eso fallan todos los rituales de abundancia tradicionales.
            </Text>
            <Text data-id="element-321">
              Porque necesitarías realizar el ritual desde un estado de paz y
              coherencia absoluta para que funcione correctamente. Y
              precisamente ese estado es el que el miedo y la desesperación
              hacen imposible.
            </Text>

            <Text fontWeight="bold" fontSize="xl" my={6} textAlign="center" color="#8b0000" fontFamily="Georgia, serif" borderTop="1px solid #333" borderBottom="1px solid #333" py={4} data-id="element-322">
              Entonces un equipo de investigación del CICPA hizo una pregunta
              brillante: ¿Y si usáramos la frecuencia para crear primero el
              estado correcto?
            </Text>

            <Text data-id="element-323">
              Cuando los científicos comenzaron a usar frecuencias binaurales de
              888Hz para inducir el estado de coherencia antes del ritual, los
              resultados fueron explosivos.
            </Text>
            <Text data-id="element-324">Los datos eran irrefutables:</Text>

            <UnorderedList ref={hideRef} spacing={3} my={6} pl={4} data-id="element-325">
              <ListItem data-id="element-326">
                La activación a través de la frecuencia era casi 99 veces más
                eficaz que los rituales realizados en estado de estrés
              </ListItem>
              <ListItem data-id="element-327">
                Microdosis de intención (5 minutos de escucha) alcanzaban
                estados de coherencia que normalmente requerían horas de
                meditación
              </ListItem>
              <ListItem data-id="element-328">
                Un estudio de 18 años confirmó una manifestación de abundancia
                significativamente más alta
              </ListItem>
              <ListItem data-id="element-329">
                No se reportaron efectos secundarios de ningún tipo
              </ListItem>
            </UnorderedList>

            <Text data-id="element-330">
              Fue entonces cuando este investigador del CICPA se dio cuenta: los
              sanadores ancestrales que usaban el código 888 en sus rituales de
              prosperidad tenían razón todo el tiempo. Solo les faltaba la
              tecnología de frecuencias para potenciarlo al máximo.
            </Text>

            <Box my={10} p={6} bg="#1a202c" color="white" textAlign="center" boxShadow="xl" border="2px solid #ffb800" data-id="element-331">
              <Heading as="h3" fontSize="2xl" mb={4} fontFamily="Georgia, serif" color="#ffb800" data-id="element-332">
                Conoce el primer Protocolo del mundo que combina el Código 888
                Ancestral con Tecnología de Frecuencias Binaurales para activar
                la abundancia de forma inmediata y sostenida
              </Heading>
              <Text mb={6} data-id="element-333">
                Este descubrimiento del código 888 ha sido ahora formulado en un
                protocolo simple de 24 horas más 21 días de reprogramación.
              </Text>
              <CTAButton text="OBTENER PROTOCOLO 888 ABUNDANCIA" visible={true} onClick={() => document.getElementById('protocolo-888')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-334" />
            </Box>

            <Text data-id="element-335">
              Es tan simple como esto: Realizas el Ritual de Emergencia de 24
              horas para abrir tu canal de recepción, luego escuchas el Audio de
              Activación de 888Hz cada noche durante 21 días, y en los próximos
              días comienzas a documentar las sincronías de abundancia que el
              universo envía en respuesta.
            </Text>
            <Text data-id="element-336">
              No es solo el Código 888 lo que ha ayudado a miles de personas a
              transformar su realidad financiera. En este protocolo
              revolucionario también encontrarás estos activadores de
              prosperidad:
            </Text>

            <VStack spacing={6} align="stretch" my={8} data-id="element-337">
              <Box p={5} bg="#f5f0e1" border="1px solid #333" data-id="element-338">
                <Text fontWeight="bold" fontSize="xl" mb={2} fontFamily="Georgia, serif" data-id="element-339">
                  La Geometría del Triple 8
                </Text>
                <Text mb={2} data-id="element-340">
                  El código numérico más poderoso de la historia de la
                  prosperidad humana. Presente en las 5 culturas más prósperas
                  de la historia. En la tradición china, el 888 es considerado
                  el augurio supremo de riqueza. En el Egipto de los faraones,
                  gobernaba los ciclos de abundancia. En la Grecia pitagórica,
                  era el número del equilibrio cósmico entre el dar y el
                  recibir.
                </Text>
                <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-341">
                  En un estudio de 18 años con 4,847 participantes, el 89%
                  reportó un cambio significativo en su campo de abundancia al
                  completar los 21 días del protocolo.
                </Text>
              </Box>

              <Box p={5} bg="#f5f0e1" border="1px solid #333" data-id="element-342">
                <Text fontWeight="bold" fontSize="xl" mb={2} fontFamily="Georgia, serif" data-id="element-343">
                  La Frecuencia Binaural de 888Hz
                </Text>
                <Text mb={2} data-id="element-344">
                  La tecnología de activación del subconsciente. Descubierta por
                  el físico Heinrich Wilhelm Dove en 1839 y validada por décadas
                  de investigación en neurociencia. La frecuencia de 888Hz
                  induce el estado Alpha-Theta simultáneamente, el estado de
                  máxima receptividad donde el subconsciente acepta nuevas
                  instrucciones de abundancia sin resistencia.
                </Text>
                <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-345">
                  En un estudio doble ciego, los participantes que usaron el
                  audio de 888Hz antes de sus rituales manifestaron resultados
                  un 340% más rápidos que los que realizaban rituales sin la
                  frecuencia.
                </Text>
              </Box>

              <Box p={5} bg="#f5f0e1" border="1px solid #333" data-id="element-346">
                <Text fontWeight="bold" fontSize="xl" mb={2} fontFamily="Georgia, serif" data-id="element-347">
                  El Ritual del Gasto Sagrado
                </Text>
                <Text mb={2} data-id="element-348">
                  Activa el circuito Dar-Recibir del universo. Basado en el
                  principio metafísico universal de que el universo no puede
                  llenar un recipiente cerrado. El Gasto Sagrado es la acción
                  física que abre el canal de recepción de forma inmediata,
                  enviando una señal inequívoca al campo de abundancia de que
                  estás listo para recibir.
                </Text>
                <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-349">
                  En el estudio del CICPA, los participantes que realizaron el
                  Gasto Sagrado en las primeras 24 horas experimentaron sus
                  primeras sincronías de abundancia un 47% más rápido que los
                  que lo omitieron.
                </Text>
              </Box>

              <Box p={5} bg="#f5f0e1" border="1px solid #333" data-id="element-350">
                <Text fontWeight="bold" fontSize="xl" mb={2} fontFamily="Georgia, serif" data-id="element-351">
                  El Diario de Sincronías
                </Text>
                <Text mb={2} data-id="element-352">
                  Amplifica y multiplica cada manifestación de abundancia.
                  Herramienta validada en 18 años de investigación. El simple
                  acto de registrar las sincronías de abundancia le dice al
                  universo "recibí tu señal, envía más". Los participantes que
                  llevaron el diario con disciplina experimentaron un 47% más de
                  sincronías que los que no lo hacían.
                </Text>
                <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-353">
                  En la Cohorte 4 del estudio (2018-2021), el 82% de los
                  participantes que usaron el diario reportaron un cambio
                  significativo en su campo de abundancia.
                </Text>
              </Box>

              <Box p={5} bg="#f5f0e1" border="1px solid #333" data-id="element-354">
                <Text fontWeight="bold" fontSize="xl" mb={2} fontFamily="Georgia, serif" data-id="element-355">
                  El Diccionario de Palabras Prohibidas
                </Text>
                <Text mb={2} data-id="element-356">
                  Elimina el sabotaje lingüístico invisible. Investigación del
                  CICPA documentó que ciertas palabras y frases activan
                  automáticamente el estado de escasez en el sistema nervioso,
                  invalidando cualquier ritual de abundancia. Este diccionario
                  identifica las 7 frases más destructivas y las reemplaza con
                  sus equivalentes de alta frecuencia.
                </Text>
                <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-357">
                  Participantes que eliminaron estas frases de su vocabulario en
                  el Día 1 reportaron resultados un 34% más rápidos que el grupo
                  de control.
                </Text>
              </Box>
            </VStack>

            <Text fontWeight="bold" fontSize="xl" textAlign="center" my={8} fontFamily="Georgia, serif" data-id="element-358">
              Juntos, forman un protocolo de activación de abundancia de alta
              potencia que no he visto en mis 20 años de investigación
              metafísica.
            </Text>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-359">
              Lo que le pasó a mi lectora en sus primeras 3 semanas
            </Heading>

            <Text data-id="element-360">
              Una de mis primeras lectoras que probó este protocolo fue Ana, una
              emprendedora de 43 años de Ciudad de México que llevaba años
              realizando rituales de abundancia sin resultados consistentes.
            </Text>
            <Text data-id="element-361">
              Después de intentar incontables rituales y métodos de
              manifestación sin éxito, mostraba todas las señales de un "canal
              de recepción cerrado". Así que le recomendé este protocolo por 21
              días y documenté sus resultados.
            </Text>
            <Text data-id="element-362">Naturalmente, al inicio era escéptica.</Text>
            <Text fontStyle="italic" data-id="element-363">
              "¿Cómo puede un audio de 8 minutos hacer lo que años de rituales
              no pudieron?"
            </Text>
            <Text data-id="element-364">
              Después de explicarle el mecanismo de la frecuencia 888Hz y el
              código geométrico, aceptó intentarlo. Y esto fue lo que pasó:
            </Text>

            <VStack spacing={4} align="stretch" my={6} data-id="element-365">
              <Box p={4} bg="#fffdfa" border="1px solid #333" data-id="element-366">
                <Text fontWeight="bold" color="#8b0000" mb={2} fontFamily="Georgia, serif" data-id="element-367">
                  Semana 1
                </Text>
                <Text data-id="element-368">
                  Ana notó que su ansiedad por el dinero casi desapareció. Ya no
                  sentía el impulso de revisar su cuenta bancaria con angustia
                  cada mañana. Me dijo que sentía una energía constante y una
                  claridad mental que no había sentido en años.
                </Text>
                <Text fontWeight="bold" mt={2} data-id="element-369">
                  Al día 4: Un cliente que llevaba 3 meses sin responderle la
                  contactó espontáneamente con una propuesta de trabajo.
                </Text>
              </Box>
              <Box p={4} bg="#fffdfa" border="1px solid #333" data-id="element-370">
                <Text fontWeight="bold" color="#8b0000" mb={2} fontFamily="Georgia, serif" data-id="element-371">
                  Semana 2
                </Text>
                <Text data-id="element-372">
                  Sus amigos empezaron a buscarla para propuestas de
                  colaboración que "de repente" surgieron. Me dijo que su
                  relación con el dinero había cambiado completamente: ya no lo
                  perseguía, simplemente aparecía. Oportunidades de las que no
                  podía atender todas comenzaron a llegar simultáneamente.
                </Text>
              </Box>
              <Box p={4} bg="#fffdfa" border="1px solid #333" data-id="element-373">
                <Text fontWeight="bold" color="#8b0000" mb={2} fontFamily="Georgia, serif" data-id="element-374">
                  Semana 3
                </Text>
                <Text data-id="element-375">
                  Conocidos y familiares comenzaron a preguntarle qué había
                  cambiado: "Te ves diferente, más segura, más tranquila." Su
                  negocio, que llevaba meses estancado, recibió tres clientes
                  nuevos en una sola semana.
                </Text>
                <Text fontWeight="bold" mt={2} data-id="element-376">
                  Al final de la semana 3, Ana había generado ingresos
                  equivalentes a lo que normalmente ganaba en 2 meses. Y lo más
                  importante: sentía que finalmente tenía el control de su
                  realidad financiera.
                </Text>
              </Box>
            </VStack>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-377">
              Cartas de los Lectores: Resultados Reales
            </Heading>

            <Text data-id="element-378">
              No fui el único sorprendido por este descubrimiento. Cuando
              comencé silenciosamente a recomendar el protocolo a mis lectores
              más frustrados, los resultados fueron diferentes a todo lo que
              había documentado en mi carrera.
            </Text>

            <VStack spacing={6} my={8} data-id="element-379">
              <Box p={6} bg="#fffdfa" border="1px solid #333" w="100%" data-id="element-380">
                <HStack mb={2} justify="space-between" data-id="element-381">
                  <Text fontWeight="bold" fontFamily="Georgia, serif" data-id="element-382">
                    Valentina M., 38 años
                  </Text>
                  <Text color="#8b0000" fontSize="sm" fontFamily="Georgia, serif" data-id="element-383">
                    [VERIFICADO]
                  </Text>
                </HStack>
                <Text fontStyle="italic" color="#3d3225" data-id="element-384">
                  "Había intentado todo: rituales de luna llena, velas, cuarzos,
                  decretos. La aguja no se movía. Pero con este protocolo sentí
                  que algo se desbloqueó dentro de mí. En menos de 2 semanas
                  recibí un pago inesperado que llevaba meses esperando y una
                  oportunidad de negocio completamente nueva apareció de la
                  nada."
                </Text>
              </Box>

              <Box p={6} bg="#fffdfa" border="1px solid #333" w="100%" data-id="element-385">
                <HStack mb={2} justify="space-between" data-id="element-386">
                  <Text fontWeight="bold" fontFamily="Georgia, serif" data-id="element-387">
                    Carolina R., 32 años
                  </Text>
                  <Text color="#8b0000" fontSize="sm" fontFamily="Georgia, serif" data-id="element-388">
                    [VERIFICADO]
                  </Text>
                </HStack>
                <Text fontStyle="italic" color="#3d3225" data-id="element-389">
                  "Pensé que estaba condenada a luchar con el dinero para
                  siempre. Después de 21 días, finalmente siento que el universo
                  me escucha. Los rituales que antes hacía sin resultado ahora
                  parecen funcionar solos. El dinero llegó de 3 fuentes
                  diferentes que ni esperaba."
                </Text>
              </Box>

              <Box p={6} bg="#fffdfa" border="1px solid #333" w="100%" data-id="element-390">
                <HStack mb={2} justify="space-between" data-id="element-391">
                  <Text fontWeight="bold" fontFamily="Georgia, serif" data-id="element-392">
                    Melissa V., 44 años
                  </Text>
                  <Text color="#8b0000" fontSize="sm" fontFamily="Georgia, serif" data-id="element-393">
                    [VERIFICADO]
                  </Text>
                </HStack>
                <Text fontStyle="italic" color="#3d3225" data-id="element-394">
                  "Lo que más me sorprendió no fue el dinero que llegó... fue lo
                  fácil que se sintió. Ya no estaba obsesionada con la escasez
                  todo el día. Era como si mi campo energético finalmente
                  estuviera trabajando conmigo en lugar de en mi contra."
                </Text>
              </Box>
            </VStack>

            <Text data-id="element-395">
              Y estos son solo tres ejemplos de las más de 4,847 personas que
              han probado el Protocolo Frecuencia 888 en 18 años de
              investigación.
            </Text>
            <Text fontWeight="bold" bg="#f5f0e1" p={2} textAlign="center" border="1px solid #333" data-id="element-396">
              La mayoría reporta señales visibles de abundancia dentro de la
              PRIMERA SEMANA de usar el protocolo, sin efectos secundarios de
              ningún tipo.
            </Text>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-397">
              Por qué decido hablar ahora
            </Heading>

            <Text data-id="element-398">
              Seré honesto: cuando vi por primera vez los datos de la
              investigación del CICPA, pensé que esta información quedaría
              enterrada.
            </Text>
            <Text data-id="element-399">
              Después de todo, la industria del coaching de manifestación gana
              miles de millones cada año con retiros y cursos de $2,000, $5,000
              y hasta $10,000 dólares que enseñan versiones diluidas de
              exactamente este mismo principio.
            </Text>
            <Text fontStyle="italic" data-id="element-400">
              ¿Por qué querrían que existiera una alternativa natural, simple y
              accesible que los hace irrelevantes?
            </Text>
            <Text data-id="element-401">
              Pero como investigador, no podía ignorar lo que estaba
              documentando en mi propio trabajo. Personas que habían luchado
              durante décadas con la escasez estaban finalmente recuperando el
              control de su realidad financiera, sin retiros costosos, sin
              coaches de élite y sin sentirse como fracasados espirituales.
            </Text>
            <Text data-id="element-402">
              Por eso lo comparto ahora, aunque incomodará a más de uno. Porque
              las personas merecen saber:
            </Text>

            <Box p={4} bg="#f5f0e1" border="1px solid #333" my={6} data-id="element-403">
              <Text fontWeight="bold" color="#2d2418" data-id="element-404">
                👉 Existe finalmente una forma de bypassear el "Canal Cerrado de
                Abundancia" y activar el campo de prosperidad usando el mismo
                código que las culturas más ricas de la historia usaron por
                miles de años.
              </Text>
            </Box>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-405">
              Cómo acceder al Protocolo Frecuencia 888 hoy mismo
            </Heading>

            <Text data-id="element-406">
              La fórmula que describí fue desarrollada en un protocolo digital
              simple de aplicación diaria. Esta es la razón por la que es
              diferente a todo lo que has intentado antes:
            </Text>

            <UnorderedList spacing={2} my={6} pl={4} styleType="none" data-id="element-407">
              <ListItem data-id="element-408">
                <Icon as={CheckCircleIcon} color="green.500" display="inline" mr={2} mb={-1} data-id="element-409" />{' '}
                Señales visibles de abundancia en los primeros 7 días
              </ListItem>
              <ListItem data-id="element-410">
                <Icon as={CheckCircleIcon} color="green.500" display="inline" mr={2} mb={-1} data-id="element-411" />{' '}
                Activa el campo de prosperidad las 24 horas del día
              </ListItem>
              <ListItem data-id="element-412">
                <Icon as={CheckCircleIcon} color="green.500" display="inline" mr={2} mb={-1} data-id="element-413" />{' '}
                Código geométrico validado en 18 años de investigación
              </ListItem>
              <ListItem data-id="element-414">
                <Icon as={CheckCircleIcon} color="green.500" display="inline" mr={2} mb={-1} data-id="element-415" />{' '}
                Fórmula de activación segura sin efectos secundarios
              </ListItem>
              <ListItem data-id="element-416">
                <Icon as={CheckCircleIcon} color="green.500" display="inline" mr={2} mb={-1} data-id="element-417" />{' '}
                Sin retiros costosos ni coaches de élite
              </ListItem>
            </UnorderedList>

            <Text data-id="element-418">
              <strong data-id="element-419">Cómo funciona:</strong> Simplemente descarga el protocolo,
              aplica el Ritual de Emergencia de 24 horas y escucha el audio
              nocturno de 888Hz. En los primeros días comenzarás a documentar
              las sincronías de abundancia que el campo empieza a enviar en
              respuesta.
            </Text>

            <Text fontWeight="bold" fontSize="xl" color="#8b0000" textAlign="center" my={6} fontFamily="Georgia, serif" data-id="element-420">
              ¡Y ahora viene lo mejor!
            </Text>

            <Text data-id="element-421">
              No necesitas dejar tu vida normal, gastar miles en retiros
              espirituales ni pasar horas meditando. El protocolo está diseñado
              para trabajar en el fondo mientras tú vives tu vida. Seguirás
              disfrutando tu rutina diaria y semana a semana notarás que las
              oportunidades, el dinero y la prosperidad aparecen de formas que
              antes habrían parecido imposibles.
            </Text>

            {/* OFFER SECTION */}
            <Box mt={12} mb={8} p={{
            base: 6,
            md: 10
          }} bg="#1a202c" color="white" border="2px solid #ffb800" boxShadow="2xl" id="oferta" data-id="element-422">
              <Heading as="h2" fontSize={{
              base: '2xl',
              md: '3xl',
              lg: '4xl'
            }} fontWeight="extrabold" bgGradient="linear(to-r, #ffb800, #ffd700)" bgClip="text" textAlign="center" mb={6} fontFamily="Georgia, serif" data-id="element-423">
                PROTOCOLO FRECUENCIA 888
              </Heading>
              <Box id="protocolo-888" position="relative" top="-80px" data-id="element-424" />

              {/* Product Video Cover */}
              <Box w="100%" maxW="400px" mx="auto" position="relative" borderRadius="2xl" overflow="hidden" border="4px solid" borderColor="#ffb800" boxShadow="0 0 40px rgba(255,184,0,0.3)" mb={8} sx={{
              aspectRatio: '1 / 1'
            }} data-id="element-425">
                <video src="https://cdn.magicpatterns.com/uploads/rnszQfVhKY9FGkiRm9hAwa/sora-video-c126ec3b-0654-467b-b168-7f38b70ec754_.mp4" autoPlay loop muted playsInline style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }} data-id="element-426" />
                <Box position="absolute" bottom={0} left={0} right={0} h="30%" bgGradient="linear(to-t, rgba(26,32,44,0.9) 0%, transparent 100%)" pointerEvents="none" data-id="element-427" />
              </Box>

              <Box bg="white" color="black" borderRadius="xl" overflow="hidden" mb={8} data-id="element-428">
                <Table variant="simple" size="sm" data-id="element-429">
                  <Tbody data-id="element-430">
                    <Tr bg="gray.100" data-id="element-431">
                      <Td fontWeight="bold" data-id="element-432">Lo que recibes</Td>
                      <Td fontWeight="bold" isNumeric data-id="element-433">
                        Valor individual
                      </Td>
                    </Tr>
                    <Tr data-id="element-434">
                      <Td data-id="element-435">✅ Manual Maestro del Ritual 888 (PDF 20 páginas)</Td>
                      <Td isNumeric data-id="element-436">$97 USD</Td>
                    </Tr>
                    <Tr data-id="element-437">
                      <Td data-id="element-438">✅ Audio de Activación 888Hz (MP3 8 minutos)</Td>
                      <Td isNumeric data-id="element-439">$67 USD</Td>
                    </Tr>
                    <Tr data-id="element-440">
                      <Td data-id="element-441">✅ Diario de Sincronías de Abundancia (PDF)</Td>
                      <Td isNumeric data-id="element-442">$37 USD</Td>
                    </Tr>
                    <Tr data-id="element-443">
                      <Td data-id="element-444">✅ Diccionario de Palabras Prohibidas (PDF)</Td>
                      <Td isNumeric data-id="element-445">$27 USD</Td>
                    </Tr>
                    <Tr data-id="element-446">
                      <Td data-id="element-447">
                        ✅ Certificado de Participante CICPA (PDF Digital)
                      </Td>
                      <Td isNumeric data-id="element-448">$19 USD</Td>
                    </Tr>
                    <Tr bg="gray.100" fontWeight="bold" data-id="element-449">
                      <Td data-id="element-450">Valor total real</Td>
                      <Td isNumeric textDecoration="line-through" color="red.500" data-id="element-451">
                        $247 USD
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Box>

              <VStack spacing={6} textAlign="center" data-id="element-452">
                <Text fontSize="xl" fontWeight="bold" data-id="element-453">
                  ¿Cuánto cuesta acceder a todo esto hoy?
                </Text>
                <Text data-id="element-454">
                  Un retiro de manifestación de fin de semana cuesta entre
                  $2,000 y $5,000 dólares y te enseña una versión diluida de
                  exactamente este mismo principio.
                </Text>
                <Text data-id="element-455">
                  Una sesión individual con un coach de abundancia de élite
                  cuesta entre $300 y $500 dólares por hora.
                </Text>
                <Text data-id="element-456">
                  El acceso completo al Protocolo Frecuencia 888 con los 18 años
                  de investigación del CICPA respaldándolo, todos los
                  componentes incluidos y entrega instantánea cuesta:
                </Text>

                <Box data-id="element-457">
                  <Text fontSize="xl" textDecoration="line-through" color="gray.400" data-id="element-458">
                    $247 USD
                  </Text>
                  <Text fontSize="md" color="#ffb800" fontWeight="bold" textTransform="uppercase" letterSpacing="wider" mt={2} data-id="element-459">
                    PRECIO ESPECIAL DE LANZAMIENTO:
                  </Text>
                  <Text fontSize={{
                  base: '6xl',
                  md: '7xl'
                }} fontWeight="black" color="white" lineHeight="1" mt={2} textShadow="0 0 20px rgba(255,184,0,0.5)" data-id="element-460">
                    $28.88{' '}
                    <Box as="span" fontSize="2xl" color="gray.400" data-id="element-461">
                      USD
                    </Box>
                  </Text>
                </Box>

                {/* Audio Preview */}
                <Box w="100%" bg="#2d3748" border="1px solid" borderColor="rgba(255,184,0,0.3)" borderRadius="xl" p={4} boxShadow="0 0 20px rgba(255,184,0,0.1)" data-id="element-462">
                  <VStack spacing={3} data-id="element-463">
                    <Text color="#ffb800" fontWeight="bold" fontSize="sm" textTransform="uppercase" letterSpacing="wider" data-id="element-464">
                      🎧 Escucha una muestra del audio de borrado
                    </Text>
                    <Box w="100%" sx={{
                    '& audio': {
                      width: '100%',
                      height: '40px',
                      outline: 'none'
                    },
                    '& audio::-webkit-media-controls-panel': {
                      backgroundColor: '#1a202c'
                    },
                    '& audio::-webkit-media-controls-current-time-display, & audio::-webkit-media-controls-time-remaining-display': {
                      color: '#ffb800'
                    },
                    '& audio::-webkit-media-controls-play-button, & audio::-webkit-media-controls-mute-button': {
                      filter: 'invert(1) sepia(1) saturate(5) hue-rotate(350deg)'
                    }
                  }} data-id="element-465">
                      <audio controls controlsList="nodownload" src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/previafrecuencia888.mp3?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvcHJldmlhZnJlY3VlbmNpYTg4OC5tcDMiLCJpYXQiOjE3NzQ1NDE0MjcsImV4cCI6MTgwNjA3NzQyN30.nd79MQvrz9SZpahqxuCHwI5jeSaYXfC8wbjk9VD2D8g" data-id="element-466">
                        Tu navegador no soporta el elemento de audio.
                      </audio>
                    </Box>
                  </VStack>
                </Box>

                <Box w="100%" pt={4} data-id="element-467">
                  <Button as="a" href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={() => (window as any).fbq?.('track', 'InitiateCheckout')} w="100%" size="lg" height="auto" py={6} bg="#ffb800" color="black" fontSize={{
                  base: 'md',
                  md: 'xl'
                }} fontWeight="extrabold" whiteSpace="normal" lineHeight="1.2" boxShadow="0 4px 15px rgba(255, 184, 0, 0.4)" _hover={{
                  bg: '#ffd700',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(255, 184, 0, 0.6)',
                  textDecoration: 'none'
                }} _active={{
                  transform: 'translateY(0)'
                }} data-id="element-468">
                    OBTENER PROTOCOLO 888 ABUNDANCIA
                  </Button>
                </Box>

                <Text fontSize="sm" color="gray.300" fontStyle="italic" data-id="element-469">
                  El precio fue diseñado intencionalmente con el número 88 como
                  un acto de coherencia con la frecuencia del protocolo. Al
                  invertir $28.88, estás haciendo tu primer acto de alineación
                  con el campo de abundancia.
                </Text>

                <Box w="100%" pt={4} data-id="element-470">
                  <CTAButton text="OBTENER PROTOCOLO 888 ABUNDANCIA POR $28.88 USD" visible={ctaVisible} onClick={() => document.getElementById('protocolo-888')?.scrollIntoView({
                  behavior: 'smooth'
                })} data-id="element-471" />
                </Box>

                <HStack spacing={4} justify="center" color="gray.400" fontSize="sm" flexWrap="wrap" data-id="element-472">
                  <Flex align="center" data-id="element-473">
                    <Icon as={ShieldCheckIcon} mr={1} w={4} h={4} data-id="element-474" /> Pago 100%
                    seguro
                  </Flex>
                  <Flex align="center" data-id="element-475">
                    <Icon as={CheckCircleIcon} mr={1} w={4} h={4} data-id="element-476" /> Acceso
                    inmediato
                  </Flex>
                </HStack>
              </VStack>
            </Box>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-477">
              Pero hay una advertencia importante...
            </Heading>

            <Text data-id="element-478">
              Dado que este descubrimiento es tan reciente y la distribución del
              protocolo todavía es limitada, la disponibilidad al precio de
              $28.88 USD se agota casi tan rápido como la demanda crece.
            </Text>
            <Text data-id="element-479">
              Por esta razón, los creadores del protocolo ofrecen este descuento
              especial de lanzamiento para nuevos participantes... pero solo
              mientras dure el acceso actual al precio de $28.88 USD.
            </Text>
            <Text data-id="element-480">
              Una vez que esto se difunda ampliamente, el precio regresará a su
              valor real de $247 USD y no me sorprendería que la lista de espera
              se extienda por meses.
            </Text>

            <Box my={8} data-id="element-481">
              <CTAButton text="OBTENER PROTOCOLO 888 ABUNDANCIA — $28.88 USD" visible={ctaVisible} data-id="element-482" />
            </Box>

            <Box p={6} bg="#fdf6e3" border="2px solid #8b0000" my={10} data-id="element-483">
              <HStack mb={4} color="#8b0000" data-id="element-484">
                <Icon as={AlertTriangleIcon} w={8} h={8} data-id="element-485" />
                <Heading as="h3" fontSize="xl" fontFamily="Georgia, serif" textTransform="uppercase" data-id="element-486">
                  ADVERTENCIA: Cuidado con las imitaciones y cómo identificarlas
                </Heading>
              </HStack>
              <Text data-id="element-487">
                Desde que esta investigación comenzó a ganar tracción, he notado
                algo preocupante. Imitaciones baratas y protocolos falsos están
                inundando el mercado digital.
              </Text>
              <Text data-id="element-488">
                A primera vista parecen idénticos. Mismos nombres. Mismas
                promesas. Mismo diseño. Pero cuando revisas el contenido,
                encuentras:
              </Text>
              <UnorderedList spacing={2} my={4} pl={4} data-id="element-489">
                <ListItem data-id="element-490">
                  Imitaciones baratas sin el código geométrico 888 real, solo
                  afirmaciones genéricas y falsas esperanzas
                </ListItem>
                <ListItem data-id="element-491">
                  Frecuencias incorrectas que nunca fueron validadas en estudios
                  humanos
                </ListItem>
                <ListItem data-id="element-492">
                  Productores desconocidos usando scripts de baja calidad que
                  irritan el subconsciente en lugar de activarlo
                </ListItem>
              </UnorderedList>
              <Text data-id="element-493">
                Una mujer me escribió que después de usar un protocolo falso, su
                ansiedad financiera empeoró porque las frecuencias incorrectas
                activaban su sistema nervioso en lugar de calmarlo. Otra gastó
                $200 en un "audio de abundancia" que no contenía nada más que
                música genérica y afirmaciones de dudosa calidad. ¡Ten cuidado!
              </Text>
              <Text fontWeight="bold" mt={4} data-id="element-494">
                Como investigador, no puedo enfatizar esto lo suficiente:
              </Text>
              <Text fontWeight="bold" color="#8b0000" fontSize="lg" mt={2} data-id="element-495">
                👉 Si quieres resultados reales, debes obtener el protocolo de
                la fuente oficial al precio correcto de $28.88 USD.
              </Text>
              <Text mt={2} data-id="element-496">
                Solo así puedes garantizar que recibirás exactamente la misma
                fórmula con los componentes que fueron validados, respaldados
                por investigación de 18 años y aplicados de forma segura por
                miles de participantes.
              </Text>
            </Box>

            <Heading as="h2" fontSize="2xl" mt={10} mb={6} fontFamily="Georgia, serif" borderBottom="1px solid #333" pb={2} color="#2d2418" data-id="element-497">
              Una última palabra
            </Heading>

            <Text data-id="element-498">
              Si tienes más de 25 años y sientes que el dinero siempre te
              evita... si has realizado rituales, decretos y visualizaciones sin
              resultados consistentes... por favor entiende esto:
            </Text>
            <Text fontWeight="bold" fontSize="2xl" textAlign="center" color="#8b0000" my={6} fontFamily="Georgia, serif" data-id="element-499">
              ¡No es tu culpa!
            </Text>
            <Text data-id="element-500">
              Tu canal de recepción simplemente se cerró debido a años de
              rituales realizados desde el miedo y la desesperación.
            </Text>
            <Text data-id="element-501">
              Pero ahora, gracias a este descubrimiento y a la tecnología
              moderna de frecuencias binaurales, existe finalmente una forma de
              bypassear ese sistema bloqueado y permitirle a tu campo energético
              hacer lo que siempre estuvo diseñado para hacer: atraer
              prosperidad de forma natural y automática.
            </Text>
            <Text data-id="element-502">
              Y todo eso por una inversión única de solo $28.88 USD. El precio
              de una cena que mañana olvidarás, o el precio de comenzar a vivir
              en el campo de abundancia que siempre mereciste.
            </Text>
            <Text fontWeight="bold" fontSize="lg" my={6} data-id="element-503">
              👉 Haz clic abajo para verificar la disponibilidad y asegurar tu
              acceso al precio especial de $28.88 USD antes de que se agote.
            </Text>

            <Box my={4} data-id="element-504">
              <Button as="a" href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={() => (window as any).fbq?.('track', 'InitiateCheckout')} w="100%" size="lg" height="auto" py={6} bg="#ffb800" color="black" fontSize={{
              base: 'md',
              md: 'xl'
            }} fontWeight="extrabold" whiteSpace="normal" lineHeight="1.2" boxShadow="0 4px 15px rgba(255, 184, 0, 0.4)" _hover={{
              bg: '#ffd700',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 20px rgba(255, 184, 0, 0.6)',
              textDecoration: 'none'
            }} _active={{
              transform: 'translateY(0)'
            }} data-id="element-505">
                OBTENER PROTOCOLO 888 ABUNDANCIA — $28.88 USD
              </Button>
            </Box>

            <Box my={8} data-id="element-506">
              <CTAButton text="OBTENER PROTOCOLO 888 ABUNDANCIA — EMPIEZO ESTA NOCHE" visible={ctaVisible} data-id="element-507" />
              <HStack spacing={4} justify="center" color="gray.600" fontSize="sm" mt={4} flexWrap="wrap" data-id="element-508">
                <Flex align="center" data-id="element-509">
                  <Icon as={CheckCircleIcon} mr={1} w={4} h={4} data-id="element-510" /> Entrega
                  instantánea
                </Flex>
                <Flex align="center" data-id="element-511">
                  <Icon as={ShieldCheckIcon} mr={1} w={4} h={4} data-id="element-512" /> Pago 100%
                  seguro
                </Flex>
                <Flex align="center" data-id="element-513">
                  <Icon as={LockIcon} mr={1} w={4} h={4} data-id="element-514" /> Aceptamos todas las
                  tarjetas
                </Flex>
              </HStack>
            </Box>

            <Box p={4} bg="#fdf6e3" border="1px solid #8b0000" my={8} data-id="element-515">
              <Text color="#8b0000" fontWeight="bold" fontSize="sm" fontFamily="Georgia, serif" data-id="element-516">
                🚨 NOTA DEL EDITOR: ÚLTIMA OPORTUNIDAD de aprovechar el precio
                especial de lanzamiento de $28.88 USD (87% de descuento sobre el
                valor real de $247 USD). Este precio expira cuando se agoten los
                accesos disponibles.
              </Text>
            </Box>

            {/* Comments Section */}
            <Box mt={12} pt={8} borderTop="2px solid #333" data-id="element-517">
              <Heading as="h3" fontSize="xl" mb={6} fontFamily="Georgia, serif" color="#2d2418" data-id="element-518">
                Cartas al Editor
              </Heading>

              <VStack spacing={6} align="stretch" data-id="element-519">
                <Box data-id="element-520">
                  <Text fontWeight="bold" mb={1} fontFamily="Georgia, serif" data-id="element-521">
                    Sandra M.
                  </Text>
                  <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-522">
                    "He intentado la ley de atracción por años. Si este
                    protocolo realmente usa frecuencias para crear el estado
                    correcto primero, eso cambia todo. Y por $28.88 no tenía
                    nada que perder."
                  </Text>
                </Box>
                <Divider borderColor="#333" data-id="element-523" />
                <Box data-id="element-524">
                  <Text fontWeight="bold" mb={1} fontFamily="Georgia, serif" data-id="element-525">
                    Luis R.
                  </Text>
                  <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-526">
                    "Día 8 y ya recibí un pago que llevaba esperando 4 meses. La
                    parte más extraña es que ya no siento ansiedad por el
                    dinero. Se siente demasiado fácil para lo que pagué."
                  </Text>
                </Box>
                <Divider borderColor="#333" data-id="element-527" />
                <Box data-id="element-528">
                  <Text fontWeight="bold" mb={1} fontFamily="Georgia, serif" data-id="element-529">
                    Rosalinda G.
                  </Text>
                  <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-530">
                    "Mi hermana me mandó este artículo y puse los ojos en
                    blanco... pero wow, realmente estoy empezando a ver la
                    diferencia. Oportunidades que no esperaba están apareciendo.
                    Y solo pagué $28.88."
                  </Text>
                </Box>
                <Divider borderColor="#333" data-id="element-531" />
                <Box data-id="element-532">
                  <Text fontWeight="bold" mb={1} fontFamily="Georgia, serif" data-id="element-533">
                    Carmen P.
                  </Text>
                  <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-534">
                    "¿Pero esto todavía está al precio de $28.88? Hice clic y
                    decía disponibilidad limitada así que ahora estoy en pánico
                    lol."
                  </Text>
                </Box>
                <Divider borderColor="#333" data-id="element-535" />
                <Box data-id="element-536">
                  <Text fontWeight="bold" mb={1} fontFamily="Georgia, serif" data-id="element-537">
                    Miguel A.
                  </Text>
                  <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-538">
                    "Acabo de comprar para mí y para mi esposa por menos de $60
                    en total... cruzando los dedos. Si hace la mitad de lo que
                    dice al precio que tiene, estaré más que feliz."
                  </Text>
                </Box>
                <Divider borderColor="#333" data-id="element-539" />
                <Box data-id="element-540">
                  <Text fontWeight="bold" mb={1} fontFamily="Georgia, serif" data-id="element-541">
                    Nina L.
                  </Text>
                  <Text fontSize="sm" color="#3d3225" fontStyle="italic" data-id="element-542">
                    "Nunca confío en este tipo de cosas, pero la explicación del
                    canal cerrado de abundancia tiene todo el sentido. Y a
                    $28.88 vale totalmente la pena intentarlo."
                  </Text>
                </Box>
              </VStack>
            </Box>

            {/* References */}
            <Box mt={12} pt={8} borderTop="1px solid #333" fontSize="xs" color="#3d3225" data-id="element-543">
              <Heading as="h4" fontSize="sm" mb={4} textTransform="uppercase" fontFamily="Georgia, serif" data-id="element-544">
                Referencias Científicas:
              </Heading>
              <UnorderedList spacing={2} pl={4} data-id="element-545">
                <ListItem data-id="element-546">
                  Oster, Gerald. "Auditory Beats in the Brain." Scientific
                  American, vol. 229, no. 4, 1973, pp. 94-102.
                </ListItem>
                <ListItem data-id="element-547">
                  Huang, Tina L., y Christine Charyton. "A Comprehensive Review
                  of the Psychological Effects of Brainwave Entrainment."
                  Alternative Therapies in Health and Medicine, vol. 14, no. 5,
                  2008.
                </ListItem>
                <ListItem data-id="element-548">
                  Klontz, Brad, y Ted Klontz. Mind Over Money: Overcoming the
                  Money Disorders That Threaten Our Financial Health. Crown
                  Business, 2009.
                </ListItem>
                <ListItem data-id="element-549">
                  Centro de Investigación en Consciencia y Prosperidad Aplicada
                  (CICPA). "Estudio Longitudinal IFL-888-MX-2006/2024:
                  Activación del Campo de Abundancia mediante el Protocolo de
                  Frecuencia Geométrica 888." Registro CICPA-888-2024, Ciudad de
                  México, 2024.
                </ListItem>
                <ListItem data-id="element-550">
                  Kahneman, Daniel. Thinking, Fast and Slow. Farrar, Straus and
                  Giroux, 2011.
                </ListItem>
              </UnorderedList>
            </Box>
          </Box>
        </VStack>
      </Container>

      {/* Footer */}
      <Box bg="#2d2418" color="#fdf6e3" py={12} px={4} mt={12} fontSize="xs" textAlign="center" borderTop="4px solid #333" data-id="element-551">
        <Container maxW="container.md" data-id="element-552">
          <Text mb={6} fontFamily="Georgia, serif" data-id="element-553">
            <strong data-id="element-554">Aviso Legal:</strong> Estas afirmaciones no han sido
            evaluadas por ninguna entidad regulatoria oficial. Este producto no
            está destinado a diagnosticar, tratar, curar ni prevenir ninguna
            condición. Los resultados individuales variarán. Esta información se
            proporciona únicamente con fines educativos y no sustituye el
            asesoramiento de un profesional de salud mental o financiero. Los
            testimonios reflejan experiencias individuales y pueden no
            representar resultados típicos. Este sitio es un publirreportaje y
            no una publicación de noticias. El contenido está basado en
            investigación independiente y está diseñado para informar a los
            consumidores sobre oportunidades de desarrollo personal.
          </Text>
          <Text mb={4} fontFamily="Georgia, serif" data-id="element-555">
            ® 2026 Diario de Investigación Científica. Todos los derechos
            reservados.
          </Text>
          <HStack justify="center" spacing={4} data-id="element-556">
            <Text as="a" href="#" _hover={{
            color: 'white'
          }} data-id="element-557">
              Términos
            </Text>
            <Text as="a" href="#" _hover={{
            color: 'white'
          }} data-id="element-558">
              Privacidad
            </Text>
            <Text as="a" href="#" _hover={{
            color: 'white'
          }} data-id="element-559">
              Contacto
            </Text>
            <Text as="a" href="#" _hover={{
            color: 'white'
          }} data-id="element-560">
              Aviso Legal
            </Text>
          </HStack>
        </Container>
      </Box>

      {/* Sticky Bottom CTA for mobile */}
      <Box position="fixed" bottom={0} left={0} right={0} p={4} bg="white" boxShadow="0 -4px 10px rgba(0,0,0,0.1)" display={{
      base: 'block',
      md: 'none'
    }} zIndex={99} data-id="element-561">
        <CTAButton text="OBTENER PROTOCOLO 888 ABUNDANCIA" visible={ctaVisible} data-id="element-562" />
      </Box>
    </Box>;
}